import axiosInstance from 'utils/axiosInstance';
import { get } from 'lodash/fp';

const getTimeZones = () => axiosInstance.get('/ReferenceData/GetTimeZones').then(get('data'));

export { getTimeZones };
